<template>
	<ListTile @click="tileClicked" class="cursor-pointer">




		<template v-slot:icon>
			<div style="height: 50px; width: 84px;">
				<img :src="myPayoutOptionData.payout_option.icon" alt="Payout Icon" class="w-100" />
			</div>
		</template>





		<template v-slot:details>
			<v-row no-gutters class="d-flex justify-space-between align-center justify-center w-100">


				<v-col class="font-weight-bold">{{
					myPayoutOptionData.payout_option.name
				}}</v-col>

				<v-col v-if="isDesktopDevice" class="font-weight-bold">
					{{ myPayoutOptionData.currency }}
					{{ myPayoutOptionData.currency_amount }}
				</v-col>


				<v-col v-if="isDesktopDevice">
					{{
						new Date(
							myPayoutOptionData.current_state.updated_at * 1000
						).toLocaleString(undefined, {
							year: "numeric",
							month: "long",
							day: "2-digit",
						})
					}}
				</v-col>

			</v-row>
		</template>





		<template v-if="isDesktopDevice" v-slot:append-right>
			<div class="d-flex align-center h-100">

				<div class="my-reward-status-button my-reward-status-button--pending px-6 px-lg-10" rounded="pill"
					v-if="myPayoutOptionData.current_state.state_name === 'Pending'">
					{{ myPayoutOptionData.current_state.state_name }}
				</div>

				<div class="my-reward-status-button my-reward-status-button--fulfilled my-reward px-6 px-lg-10" rounded="pill"
					v-if="myPayoutOptionData.current_state.state_name === 'Fulfilled'">
					{{ myPayoutOptionData.current_state.state_name }}
				</div>

				<div class="my-reward-status-button my-reward-status-button--fraudulent px-6 px-lg-10" rounded="pill"
					v-if="myPayoutOptionData.current_state.state_name === 'Fraudulent'">
					{{ myPayoutOptionData.current_state.state_name }}
				</div>

			</div>

		</template>


		<template v-slot:append-bottom v-if="!isDesktopDevice">
			<div class="d-flex align-start flex-column h-100">

				<div class="font-weight-bold mt-4 w-100">
					{{ myPayoutOptionData.currency }} {{ myPayoutOptionData.currency_amount }}
				</div>

				<div>
					{{
						new Date(myPayoutOptionData.current_state.updated_at * 1000).toLocaleString(undefined, {
							year: "numeric",
							month: "long",
							day: "2-digit",
						})
					}}
				</div>

				<div class="mt-4">
					<div rounded="pill" class="my-reward-status-button my-reward-status-button--pending"
						v-if="myPayoutOptionData.current_state.state_name === 'Pending'">
						{{ myPayoutOptionData.current_state.state_name }}
					</div>


					<div rounded="pill" class="my-reward-status-button my-reward-status-button--fulfilled"
						v-if="myPayoutOptionData.current_state.state_name === 'Fulfilled'">
						{{ myPayoutOptionData.current_state.state_name }}
					</div>


					<div rounded="pill" class="my-reward-status-button my-reward-status-button--fraudulent"
						v-if="myPayoutOptionData.current_state.state_name === 'Fraudulent'">
						{{ myPayoutOptionData.current_state.state_name }}
					</div>
				</div>
			</div>
		</template>
	</ListTile>
</template>



<script setup>

import { isDesktop } from "@/utils/utils.ts";
import { PayoutStore } from "@/store/PayoutStore";
import ListTile from "@/components/Tiles/List-Tile.vue";
import { computed } from "vue";

const props = defineProps({
    id: Number,
    payout: Object,
});

const emit = defineEmits(["click"]);

const payoutStore = PayoutStore();
const isDesktopDevice = isDesktop();

const myPayoutOptionData = computed(() =>
    payoutStore.MyPayoutData.find((mydata) => mydata.id === props.id)
);

const tileClicked = () => {
    payoutStore.setSelectedMyPayoutOption(myPayoutOptionData.value.id);
    emit("click");
};

</script>